import React from "react";

export function RadialDetailTooltip({ active, payload }) {
  if (!active || !payload || !payload.length) return null;
  const p = payload[0]?.payload;
  if (!p) return null;
  return (
    <div className="sd-tooltip">
      <div className="sd-tooltip-label">{p.name}</div>
      <div className="sd-tooltip-row">
        <span
          className="sd-tooltip-swatch"
          style={{ background: p.dotColor || p.fill }}
        />
        <span className="sd-tooltip-name">Amount</span>
        <span className="sd-tooltip-value">
          ₹{Math.round(p.amount).toLocaleString()}
        </span>
      </div>
      <div className="sd-tooltip-row">
        <span className="sd-tooltip-name">Share</span>
        <span className="sd-tooltip-value">{Math.round(p.value)}%</span>
      </div>
    </div>
  );
}
